import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import Form from "./Form";

function Setting() {
  const handleChipClick = useOutletContext();

  useEffect(() => {
    handleChipClick("setting");
  }, [handleChipClick]);

  return <Form />;
}

export default Setting;
